import { useEntityPanelManager } from '../../../panels/entity-panels/monitored-entities/state/entity-panel-manager';
import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { useEffect } from 'react';
import { reaction } from 'mobx';

export const useTrackHistoricalBoloPanels = () => {
    const entityPanelManager = useEntityPanelManager();
    const workspacePanel = useWorkspacePanel<'BOLO'>();

    useEffect(() => {
        return reaction(
            () => workspacePanel.isFocused,
            (val) => {
                if (
                    val &&
                    workspacePanel.linkedEntityId &&
                    entityPanelManager.historicalBoloPanels[workspacePanel.linkedEntityId]
                ) {
                    entityPanelManager.historicalBoloPanels[
                        workspacePanel.linkedEntityId
                    ].lastFocused = Date.now();
                }
            }
        );
    }, [workspacePanel, entityPanelManager]);
};
